import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { getOrderItemStatus } from '@features/order-ui/utils/order.utils';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { OrderHelper } from '@rd/helpers/order.helper';
import { Order, OrderItemStatus } from '@rd/types';

@Component({
  selector: 'rd-tcv2-success-points-transaction-status',
  templateUrl: './success-points-transaction-status.component.html',
  styleUrls: ['./success-points-transaction-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2SuccessPointsTransactionStatusComponent implements OnInit {
  @HostBinding('class.rd-tcv2-success-points-transaction-status')
  componentClass = true;

  OrderItemStatus = OrderItemStatus;

  @Input() pointsTransferOrder: Order;

  constructor(
    private iconRegistryService: IconRegistryService,
    private orderHelper: OrderHelper,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
  }

  get orderItemStatus(): OrderItemStatus {
    return getOrderItemStatus(this.pointsTransferOrder.fulfillmentStatus);
  }

  get orderIdParams(): { id: string } {
    return {
      id: this.orderHelper.displayedId(this.pointsTransferOrder),
    };
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('success');
    this.iconRegistryService.registerIcon('progress');
    this.iconRegistryService.registerIcon('error');
  }
}
